import { FC, useState } from "react";

import { StationAdditionItemDisplay } from "./station-addition.item.display";
import { StationAdditionItemEdit } from "./station-addition.item.edit";
import { IStationAdditionItemForm } from "./station-addition.models";

export const StationAdditionItem: FC<IStationAdditionItemForm> = ({
  fieldName,
  index,
  value,
  control,
  setValue,
  getValues,
  removeHandler,
}) => {
  const [inEdit, setInEdit] = useState(false);

  return (
    <>
      {!inEdit && (
        <StationAdditionItemDisplay
          fieldName={fieldName}
          setValue={setValue}
          getValues={getValues}
          control={control}
          removeHandler={removeHandler}
          index={index}
          value={value}
          onEdit={() => {
            setInEdit(true);
          }}
        />
      )}

      {inEdit && (
        <StationAdditionItemEdit
          fieldName={fieldName}
          setValue={setValue}
          getValues={getValues}
          index={index}
          value={value}
          onCancel={() => {
            setInEdit(false);
          }}
        />
      )}
    </>
  );
};
